function isMinusZero(value) {
  return 1 / value === Number.NEGATIVE_INFINITY;
}
export { isMinusZero };
//# sourceMappingURL=isMinusZero.mjs.map
